import React from 'react';

const LegendLineIcon = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 30 30" {...props}>
    <path
      strokeWidth="4"
      fill="none"
      stroke="currentColor"
      d="M0,16h10.666666666666666
            A5.333333333333333,5.333333333333333,0,1,1,21.333333333333332,16
            H32M21.333333333333332,16
            A5.333333333333333,5.333333333333333,0,1,1,10.666666666666666,16"
      className="legend-line-icon"
    />
  </svg>
);

export default LegendLineIcon;
